<script setup lang="ts">
const props = defineProps<{
    title: string,
    desc: string,
}>();
</script>

<template>
    <SectionsBase id="prices" class="background">
      <div class="container relative z-1">
        <ChipsDivider>تعرفه‌ها</ChipsDivider>
        <h2>{{ props.title }}</h2>
        <p class="text-body1-semibold text-gray-400 text-center my-6">{{ props.desc }}</p>
        <slot />
      </div>
    </SectionsBase>
</template>

<style scoped>
@reference "~/assets/css/main.css";

.background {
    @apply
    bg-linear-to-b from-primary-50 to-transparent relative
}
.background::before {
    @apply
    content-[''] w-full h-full absolute top-0 left-0 bg-[url('/img/new/backgrounds/mesh-04.webp')] opacity-70
}
</style>